import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class SuperuserExcludedPrivileges {
    @JsonProperty("ExcludedPrivileges")
    @JsonElementType(String)
    excludedPrivileges: Array<string> = [];
}
